
import { ListaEditavel } from '@/dominio/editor/comum/ListaEditavel';
import { OpcaoEditavel } from '@/dominio/editor/questoes/questao-opcao/opcao/OpcaoEditavel';
import { QuestaoOpcaoEditavel } from '@/dominio/editor/questoes/questao-opcao/QuestaoOpcaoEditavel';
import { defineComponent } from 'vue';
import BotoesEdicao from '../../comum/BotoesEdicao.vue';

export default defineComponent({
    name: 'QuestaoOpcaoVisualizacao',
    components: {
        BotoesEdicao,
    },
    props: {
        questao: { type: QuestaoOpcaoEditavel, required: true },
        ehPrimeiro: { type: Boolean, required: true },
        ehUltimo: { type: Boolean, required: true },
    },
    methods: {
        selecionar() {
            this.$emit('selecionar', this.questao);
        },
        editar() {
            this.$emit('editar', this.questao);
        },
        excluir() {
            this.$emit('excluir', this.questao);
        },
        descer() {
            this.$emit('descer', this.questao);
        },
        subir() {
            this.$emit('subir', this.questao);
        },
    },
    emits: ['selecionar', 'excluir', 'descer', 'subir', 'editar'],
});
